<template>
	<div class="EstablishProduct">
		<div class="product_number" v-if="productId">
			产品编号：{{ productInfo.productNumber }}
		</div>

		<uploadPictures @ImgList="ImgList" :searchModelList="searchModelList" ref="uploadPictures" @getModelList
			="getSearchModelList" :page-type="pageType" @downloadImgs="downloadImgs" :companyRole="companyRole" />
		<!-- 产品安全法规图片 -->
		<safePictures @ImgList="safetyImagesList" ref="safePictures" :page-type="pageType"
			@downloadImgs="downloadImgs" />
		<!-- 基本信息 -->
		<div class="Minister-top information">
			<div class="info-box-mask" v-show="loading === 'translateLoading'">
				<div class="progress">
					<el-progress type="circle" :percentage="loadingLength" :width="240"></el-progress>
				</div>
			</div>
			<div class="Minister-top-top Ministerbackground aiCss">
				<div class="Minister-top-left Minister-top-color">基本信息</div>
				<el-button type="primary" style="margin-left: 30px;" @click="aiCopywriting">AI文案</el-button>
			</div>

			<div class="information_content">
				<div class="information_Mandarin" style="margin-bottom:20px;">
					<ul ref="chosebox">
						<template v-for="(item, index) in countryList">
							<li :key="item.areaName" :class="{
								liactive: currentCountryIndex === index,
							}" @click="changeCurrentCountry(index)" v-if="
								currentCountryIndex === index ||
								countryVisible === 'all'
							">
								{{ item.name }}
							</li>
						</template>
					</ul>
					<div class="translateSync">
						<el-button type="primary" @click="translateSync" v-if="translateSyncList.length">
							同步同语言
						</el-button>
					</div>
				</div>
				<template v-for="(item, index) in countryList">
					<el-checkbox-group v-model="checkList" :key="item.areaName" v-show="currentCountryIndex === index">
						<div class="information_input" style="margin-bottom:20px;">
							<div class="information_Title">
								<span class="tips">*</span>
								标题
							</div>

							<div class="input_el input_span">
								<div style="width:24px;">
									<el-checkbox label="title" v-if="currentCountryIndex === 0"></el-checkbox>
								</div>
								<div class="newipt">
									<el-input ref="customTextarea" class="width97 custom-border-blue" type="textarea"
										placeholder="标题长度不超过75个字符" v-model="item.formData.title" maxlength="75"
										autosize show-word-limit @blur="
											formatInputValue(
												item.formData.title,
												'title'
											)
											"></el-input>
								</div>
							</div>
						</div>
						<div class="information_input" style="margin-bottom:20px;">
							<div class="information_Title">
								<span class="tips">*</span>
								商品亮点
							</div>

							<div class="input_el input_span">
								<div style="width:24px;">
									<el-checkbox label="titleDifferentiation" v-if="currentCountryIndex === 0"></el-checkbox>
								</div>
								<div class="newipt">
									<el-input ref="customTextarea" class="width97 custom-border-blue" type="textarea"
										placeholder="商品亮点长度不超过125个字符" v-model="item.formData.titleDifferentiation" maxlength="125" autosize
										show-word-limit @blur="
											formatInputValue(
												item.formData.titleDifferentiation,
												'titleDifferentiation'
											)
											"></el-input>
								</div>
							</div>
						</div>
						<div class="information_input">
							<div class="region" @click="handleCheckAllChange"></div>
							<div class="information_Title">
								<span class="tips">*</span>
								五大亮点
							</div>
							<div class="input_el input_span">
								<div style="width:24px;">
									<el-checkbox label="bluePoints" v-if="currentCountryIndex === 0"></el-checkbox>
								</div>
								<div v-for="(key, value) in item.formData
									.bluePoints" :key="value" class="newipt" style="margin-bottom:10px;">
									<el-input ref="customTextarea" class="width97 custom-border-green" type="textarea"
										autosize placeholder="五大亮点字符不能超过500个" maxlength="500" v-model="item.formData.bluePoints[value]
											" show-word-limit></el-input>
								</div>
							</div>
						</div>
						<div class="information_tips">
							5个亮点不需要全部填写，至少填写一条数据
						</div>
						<div class="information_input">
							<div class="information_Title">
								<span class="tips">*</span>
								关键字
							</div>
							<div class="input_el">
								<div style="width:24px;">
									<el-checkbox label="keyword" v-if="currentCountryIndex === 0"></el-checkbox>
								</div>
								<div class="newipt">
									<el-input ref="customTextarea" class="width97 custom-border-purple" type="textarea"
										autosize placeholder="请输入关键字" v-model="item.formData.keyword" maxlength="250"
										show-word-limit required="required"></el-input>
								</div>
							</div>
						</div>
						<div class="information_input margin-top1">
							<div class="information_Title">
								<span class="tips">*</span>
								描述
							</div>
							<div class="input_el">
								<div style="width:24px;">
									<el-checkbox label="briefIntroduction"
										v-if="currentCountryIndex === 0"></el-checkbox>
								</div>
								<div class="editor-container" style="margin-left:26px;">
									<el-card>
										<!-- <vue-ueditor-wrap
                                            ref="ueditor"
                                            :id="item.areaName"
                                            v-model="item.formData.briefIntroduction"
                                            :destroy="true"
                                            :config="myConfig"
                                        ></vue-ueditor-wrap> -->
										<quill-editor v-model="item.formData.briefIntroduction
											" :options="editorOption" @change="
												onEditorChange($event, item)
												"></quill-editor>
										<el-row type="flex" justify="space-between">
											<el-row type="flex">
												<h4>注意事项：</h4>
												<span style="color:red;">
													如果有从其它页面复制过来的文字，请先全选中复制的内容，然后点击文本编辑器中第二个按钮清除字体样式，否则无法翻译
												</span>
											</el-row>
											<div>
												{{ item.editorLength }}/2000
											</div>
										</el-row>
									</el-card>
								</div>
							</div>
						</div>
					</el-checkbox-group>
				</template>
			</div>
		</div>
		<!-- 产品信息 -->
		<productInformation @getModelList="getSearchModelList" :searchModelList="searchModelList" ref="productData" :product-info="productInfo" :exchange-rate-list="exchangeRateList"
			:page-type="pageType" @changeInfo="changeInfo" @priceChange="priceChange" @setMoneyInfo="setMoneyInfo" />
		<!-- 变体信息 -->
		<Variantinformation ref="Variant" :product-info="productInfo" :exchange-rate-list="exchangeRateList"
			:img-select-list="productImgArr" :page-type="pageType" @addImg="addImg" />
		<div class="EstablishProduct_bottom">
			<!-- <el-button type="primary"
				v-if="productInfo.isTranslation == 2"
				@click="ManualTranslation"
			>使用手动翻译</el-button> -->
			<el-button type="primary" @click="synchronization(1)" :disabled="SaveForbid" :loading="loadingTranslate"
				v-if="
					currentCountryIndex === 0 &&
					UserInfo.system === 5 &&
					pageType !== 'wait' &&
					pageType !== 'complete'
				">
				一键翻译
			</el-button>
			<el-button type="primary" @click="detectingSensitiveWords"
				v-if="UserInfo.system === 5 && pageType !== 'complete'" :loading="loadingDetection">
				检测敏感词汇
			</el-button>
			<el-button type="success" @click="save" v-if="UserInfo.system === 5 && pageType !== 'complete'"
				:loading="isLoading === 'save'">
				保存
			</el-button>
		</div>

		<el-dialog title="敏感词汇" top="4vh" width="500px;" :visible.sync="dialogSensitiveVisible"
			@close="sensitiveWords = ''">
			<el-button type="primary" @click="copySensitive" style="margin-bottom: 10px;">一键复制</el-button>
			<div v-html="sensitiveWords"></div>
			<div style="margin-top:20px;font-size: 10px;">
				PS：点击复制，输入ctrl+f，在搜索框内粘贴，即可指到敏感词汇的位置
			</div>
		</el-dialog>
		<el-dialog title="翻译店铺" :visible.sync="synchronizationDialog" width="60%" top="5vh" center
			v-loading="dialogLoding">
			<div class="fanyi-box">
				<div class="fanyi-item">
					<div class="select-css jc-sb" style="margin-top: 10px;">
						<div class="jc-sb">
							<span> 全选 </span>
						</div>
						<div>
							<el-checkbox v-model="isAllSelected"
								@change="toggleSelectAll(synchronizationList)"></el-checkbox>
						</div>
					</div>
					<div v-for="(item, i) in synchronizationList" class="select-css jc-sb" style="margin-top: 10px;"
						:key="i">
						<div class="jc-sb">
							<span>{{ item.countryChinese }} </span>
						</div>
						<div>
							<el-checkbox-group v-model="radio" v-removeAriaHidden>
								<el-checkbox class="mL-10" :key="i" :label="item.countryCode"></el-checkbox>
							</el-checkbox-group>
						</div>
					</div>
				</div>
				<div class="fanyi-item array">
					<div class="title">
						<div class="text">翻译记忆数组</div>
						<el-button type="primary" @click="addTmItem">添加</el-button>
					</div>
					<div class="tm-box">
						<div class="tm-tip">如果您已经有标准的双语句对并且希望大模型在后续翻译时能参考这些标准译文给出结果，可以使用翻译记忆功能</div>
						<div class="tm-item" v-for="(item, index) in tmList" :key="index">
							<div class="tm-row">
								<div class="tm-text">源语言：</div>
								<el-input class="tm-val" v-model="item.source" placeholder="请输入源语言" type="textarea"
									@input="item.source = item.source.trim()"></el-input>
							</div>
							<div class="tm-row">
								<div class="tm-text">目标语言：</div>
								<el-input class="tm-val" v-model="item.target" placeholder="请输入目标语言" type="textarea"
									@input="item.target = item.target.trim()"></el-input>
							</div>
							<el-button type="text" @click="tmList.splice(index, 1)" icon="el-icon-delete">删除</el-button>
							<el-divider></el-divider>
						</div>
					</div>
				</div>
			</div>


			<span slot="footer" class="dialog-footer">
				<el-button @click="synchronizationDialog = false">取 消</el-button>
				<el-button type="primary" @click="clickSynchronization">确 定</el-button>
			</span>
		</el-dialog>
		<!-- AI文案 -->
		<el-dialog title="AI文案" :visible.sync="aiCopyDialogVisible" width="700px" :close-on-click-modal="false"
			:append-to-body="true" top="60px">
			<ai-copywriter :product-data="currentProduct" @close="aiCopyDialogVisible = false"
				@generated="handleCopyGenerated" />
		</el-dialog>
	</div>
	<!-- </router-view> -->
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '../../../api/api/api'
import cropper from './elasticFrame/cropper'
import setUp from './EstablishProductClassificationModular/setUp'
import uploadPictures from './EstablishProductClassificationModular/uploadPictures'
import safePictures from './EstablishProductClassificationModular/safePictures'
import productInformation from './EstablishProductClassificationModular/productInformation'
import Variantinformation from './EstablishProductClassificationModular/Variant_information'
import VueUeditorWrap from 'vue-ueditor-wrap'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import addQuillTitle from './edit/quill-title'
import AiCopywriter from './components/aiCopywriter.vue';

const translateSyncCountryList = [
	['GB', 'US', 'CA', 'AU', 'AE', 'IN', 'SG'],
	['ES', 'MX'],
]
let loadingTime, translateStatusTimer

export default {
	name: 'EstablishProduct',
	components: {
		cropper,
		setUp,
		uploadPictures,
		safePictures,
		productInformation,
		Variantinformation,
		VueUeditorWrap,
		quillEditor,
		AiCopywriter
	},
	beforeRouteLeave(to, from, next) {
		if (to.name === 'conmmoditySummary') {
			// 返回时保持缓存不变（true）
			this.$store.commit('SET_IS_CACHE_CONMMODITY', true)
		} else {
			// 去其他地方，关闭缓存
			this.$store.commit('SET_IS_CACHE_CONMMODITY', false)
		}
		next()
	},
	data() {
		return {
			SaveForbid: false,
			productId: '',
			productIds: {},
			// AI文案dialog
			aiCopyDialogVisible: false,
			generatedCopy: '',
			currentProduct: {},
			// 国家列表
			countryList: [
				{
					name: '中国',
					areaName: 'ZH',
					translateUpperName: 'ZH',
					translateLowerName: 'zh',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'ZH',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '英国',
					areaName: 'GB',
					translateUpperName: 'EN',
					translateLowerName: 'en',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'GB',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '德国',
					areaName: 'DE',
					translateUpperName: 'DE',
					translateLowerName: 'de',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'DE',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '法国',
					areaName: 'FR',
					translateUpperName: 'FRA',
					translateLowerName: 'fr',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'FR',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '意大利',
					areaName: 'IT',
					translateUpperName: 'IT',
					translateLowerName: 'it',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'IT',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '西班牙',
					areaName: 'ES',
					translateUpperName: 'ES',
					translateLowerName: 'es',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'ES',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '荷兰',
					areaName: 'NL',
					translateUpperName: 'NL',
					translateLowerName: 'nl',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'NL',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '瑞典',
					areaName: 'SE',
					translateUpperName: 'SE',
					translateLowerName: 'se',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'SE',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '波兰',
					areaName: 'PL',
					translateUpperName: 'PL',
					translateLowerName: 'pl',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'PL',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '沙特阿拉伯',
					areaName: 'SA',
					translateUpperName: 'SA',
					translateLowerName: 'sa',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'SA',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '美国',
					areaName: 'US',
					translateUpperName: 'US',
					translateLowerName: 'us',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'US',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '加拿大',
					areaName: 'CA',
					translateUpperName: 'CA',
					translateLowerName: 'ca',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'CA',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '墨西哥',
					areaName: 'MX',
					translateUpperName: 'MX',
					translateLowerName: 'mx',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'MX',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '日本',
					areaName: 'JP',
					translateUpperName: 'JP',
					translateLowerName: 'jp',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'JP',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '澳洲',
					areaName: 'AU',
					translateUpperName: 'AU',
					translateLowerName: 'au',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'AU',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '阿联酋',
					areaName: 'AE',
					translateUpperName: 'AE',
					translateLowerName: 'ae',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'AE',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '新加坡',
					areaName: 'SG',
					translateUpperName: 'SG',
					translateLowerName: 'sg',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'SG',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '印度',
					areaName: 'IN',
					translateUpperName: 'IN',
					translateLowerName: 'in',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'IN',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
				{
					name: '巴西',
					areaName: 'BR',
					translateUpperName: 'BR',
					translateLowerName: 'br',
					formData: {
						title: '',
						titleDifferentiation: '',
						areaName: 'BR',
						bluePoints: ['', '', '', '', ''],
						keyword: '',
						briefIntroduction: '',
					},
					editorLength: 0,
				},
			],
			currentCountryIndex: 0, // 当前国家下标
			countryVisible: '', // 是否显示全部国家
			editorOption: {
				placeholder: '请输入...',
				modules: {
					toolbar: ['bold', 'clean'],
				},
			},
            tmList:[],
			// myConfig: {
			//     autoHeightEnabled: false,
			//     initialFrameHeight: 500,
			//     initialFrameWidth: "100%",
			//     UEDITOR_HOME_URL: "/UEditor/",
			//     toolbars: [["source", "bold", "spechars"]],
			//     wordCount: true,
			//     maximumWords: 2000,
			//     enableAutoSave: false,
			//     enableContextMenu: false,
			//     serverUrl: "",
			//     autoFloatEnabled: false,
			// },
			UserInfo: {},
			loading: '',
			loadingLength: 0,
			checkList: ['title', 'titleDifferentiation', 'bluePoints', 'keyword', 'briefIntroduction'],
			productInfo: {},
			exchangeRateList: [],
			productImgArr: [],
			//产品安全图片
			safeProductImgArr: [],
			substitutiont: true,
			lanLength: '',
			bianPrice: '',
			pageType: '',
			isIndeterminate: false,
			checkAll: false,
			isLoading: '',
			loadingTranslate: false,

			productPrice: {},
			isTranslate: false,
			loadingDetection: false,
			sensitiveWords: '',
			copyKey: '',
			dialogSensitiveVisible: false,
			synchronizationDialog: false,
			radio: [],
			synchronizationList: null,
			existingSynchronizationList: null,
			dialogLoding: false,
			isAllSelected: false,
			searchModelList: [],
			companyRole: false, //公司权限
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		if (this.$route.params.id) {
			this.productId = this.$route.params.id
		}
		if (this.$route.params.pageType) {
			this.pageType = this.$route.params.pageType
		}
		this.getRole();
		this.getProductInfo()
		this.getExchangeRateList()
		this.getSearchModelList();
	},
	mounted() {
		addQuillTitle()
	},
	beforeDestroy() {
		this.clearTranslateTimer()
	},
	computed: {
		translateSyncList() {
			const countryInfo = this.countryList[this.currentCountryIndex]
			const countryTag = countryInfo.areaName
			const translateSyncList = translateSyncCountryList.find((item) =>
				item.includes(countryTag)
			)
			return translateSyncList || []
		},
	},
	methods: {
		getRole() {
			ajaxPost(
				Baseurl + 'companyController/getCompanyIdsApplyOrderExport'
			).then((res) => {
				this.companyRole = res.data.data.includes(this.UserInfo.company.id)
			})
		},
		getSearchModelList(){
			ajaxGet(Baseurl + 'amazonProductCrawlModel/selectAllProcessedProductModels').then((response)=>{
				if(response.status == 200 && response.data && response.data.code == 200){
					this.searchModelList = response.data.data;
				}
			})
		},
        addTmItem(){
            this.tmList.push({
                source: '',
                target: ''
            })
        },
		// AI文案
		aiCopywriting() {
			this.currentProduct = {}
			this.aiCopyDialogVisible = true
		},
		// 处理生成的文案
		handleCopyGenerated(copy) {
			this.generatedCopy = copy
			console.log(this.generatedCopy, 'this.generatedCopy');
			this.countryList[this.currentCountryIndex].formData.title = this.generatedCopy.title
			this.countryList[this.currentCountryIndex].formData.keyword = this.generatedCopy.keyword
			this.countryList[this.currentCountryIndex].formData.briefIntroduction = this.generatedCopy.description
			this.countryList[this.currentCountryIndex].formData.bluePoints = [
				this.generatedCopy.UPC1,
				this.generatedCopy.UPC2,
				this.generatedCopy.UPC3,
				this.generatedCopy.UPC4,
				this.generatedCopy.UPC5
			]
			this.aiCopyDialogVisible = false
			this.$message.success('文案使用成功!')
		},
		clickSynchronization() {
			this.translate(false)
			this.synchronizationDialog = false
		},
		toggleSelectAll(synchronizationList) {
			if (this.isAllSelected) {
				this.radio = synchronizationList.map(item => item.countryCode);
			} else {
				this.radio = [];
			}
		},
		async synchronization(e) {
			this.synchronizationDialog = true
			this.radio = []
            this.tmList = [{source: '', target: ''}]
			let API = Baseurl + 'amazonProductListing/selectAmazonShopByRid'
			let paramsData = { rid: JSON.parse(localStorage.getItem('role')).rid, system: JSON.parse(localStorage.getItem('role')).system }
			ajaxPost(API, paramsData)
				.then((res) => {
					this.existingSynchronizationList = res.data.data
					API = Baseurl + 'countryMarketController/selectCountryMarketList'
					ajaxPost(API)
						.then((res) => {
							this.synchronizationList = res.data.data
							this.existingSynchronizationList.forEach(item1 => {
								const isExists = this.synchronizationList.some(item2 => item2.countryCode === item1.countryMark);
								if (isExists) {
									this.radio.push(item1.countryMark)
									console.log(isExists, item1, this.radio, 'isExists');
								}
							});
						})
						.catch((e) => {
							console.log(e)
						})
				})
				.catch((e) => {
					console.log(e)
				})
			this.selectTemporary = e
		},
		setMoneyInfo(data) {
			this.productPrice = data
		},
		// 获取产品信息
		getProductInfo() {
			let API = ''
			let parasmData = {}
			if (this.productId) {
				API = Baseurl + 'productController/selectById'
				parasmData.id = this.productId
				this.$nextTick(() => {
					this.$refs.Variant.loadingTable = true
				})
			} else {
				API =
					Baseurl +
					'commonSettingController/getCommonSettingByStaffId'
				parasmData.staffId = this.UserInfo.rid
			}
			ajaxPost(API, parasmData).then((res) => {
				const { data: responseData } = res
				if (responseData.code === 200) {
					const { data } = responseData
					if (this.productId) {
						const { product, products } = data
						// 产品图片
						this.$refs.uploadPictures.addImgList(
							product.productImgUrls
						)
						// 产品图片
						this.$refs.safePictures.addImgList(
							product.productSafetyImages
						)
						this.$refs.Variant.variation_theme = product.variationTheme;
						// 基本信息
						const newCountryList = []
						this.countryList.forEach((item) => {
							products.forEach((key) => {
								if (item.areaName === key.areaName) {
									item.formData.id = key.id
									item.formData.title = key.title
									item.formData.titleDifferentiation = key.titleDifferentiation
									item.formData.bluePoints = key.bluePoints
									item.formData.keyword = key.keyword
									item.formData.briefIntroduction =
										key.briefIntroduction
									newCountryList.push(item)
								}
							})
						})
						this.countryList = newCountryList
						if (product.areaName === 'ZH') {
							this.countryVisible = 'all'
						}
						// 处理productIds,保存的时候添加在products中
						products.forEach((item) => {
							this.productIds[item.areaName] = item.id
						})
						// 产品信息
						product.sourceLink = product.sourceLinks
						product.productPriceObject = product.productPriceObject
							? JSON.parse(product.productPriceObject)
							: {}
						this.productInfo = product
						// console.log(product.isTranslation)
						if (product.isTranslation === 2) {
							this.getTranslateStatus()
							// console.log(product.translationTime)
							if (!product.translationTime) {
								this.$message.warning(
									'翻译连接超时，请重新翻译'
								)
								this.loadingTranslate = false
								this.SaveForbid = false
							} else {
								const limitTime = 3600 * 1000 * 2
								const nowTime = new Date().getTime()
								const translateTime = new Date(
									product.translationTime
								).getTime()

								if (nowTime - translateTime > limitTime) {
									this.$message.warning(
										'翻译连接超时，请重新翻译'
									)
									this.loadingTranslate = false
									this.SaveForbid = false
								}
							}
						}

						this.getProductVariantList()
					} else {
						data.areaName = 'ZH'
						data.productStatus = 'New'
						data.statusAudit = '2'
						data.productPriceObject = {}
						data.sourceLink = ['']
						data.productPrice = ''
						data.priceCurrency = 'RMB'
						data.remarks = ''
						this.productInfo = data
					}
				} else {
					const { data } = responseData
					this.$message({
						type: 'error',
						message: data,
					})
				}
			})
		},
		// 获取产品变体信息
		getProductVariantList() {
			const API = Baseurl + 'productController/getVariantInfoById'
			const paramsData = { id: this.productId }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				this.$refs.Variant.changeLoading('loadingTable')
				if (code === 200) {
					const { variantEans, variants } = data

					// 默认取 variants 中的值，如果 variantEans 有值就用 variantEans
					let tempVariantsArr = variants
					if (Array.isArray(variantEans) && variantEans.length) {
						tempVariantsArr = variantEans
						tempVariantsArr.forEach((item) => {
							item.sku = item.childSku
						})
					}
					// 变体信息
					tempVariantsArr.forEach((item) => {
						item.areaName = this.productInfo.areaName
						item.productPrice = JSON.parse(item.productPrice)
						const showPrice =
							Object.keys(item.productPriceObject).length &&
							item.productPriceObject[this.productInfo.areaName]
						item.showPrice = showPrice && showPrice.value
						item.imagesList = item.imagesList || []
					})
					this.$refs.Variant.addTableData(tempVariantsArr)
				}
			})
		},
		// 获取汇率列表
		getExchangeRateList() {
			ajaxPost(Baseurl + 'rateController/getRate').then((res) => {
				const { data: responseData } = res
				if (responseData.code === 200) {
					const { data } = responseData
					this.exchangeRateList = data
					// console.log("汇率数据：", this.exchangeRateList);
				}
			})
		},
		// 产品信息子组件改变值时响应
		changeInfo(data) {
			// console.log("productInfo", data);
			const { key, value } = data
			this.productInfo[key] = value
			if (key === 'productPriceObject') {
				this.$refs.Variant.getMsgFormSon(value, 'all')
			}
		},
		// 产品图片子组件 响应 变体信息子组件 中上传的图片
		addImg(file) {
			this.$refs.uploadPictures.addImg(file)
		},
		// 产品图片子组件 中上传的图片列表
		ImgList(ImgList) {
			this.productImgArr = ImgList
		},
		safetyImagesList(ImgList) {
			this.safeProductImgArr = ImgList
		},
		handleSaveData() {
			if(this.$refs.Variant.tableData.length > 0){
				console.log(this.$refs.Variant.tableData);
				console.log(this.$refs.Variant.variation_theme);
				const map1 = {
					"color": "COLOR",
					"size": "SIZE",
					"numberOfItems": "NUMBER_OF_ITEMS",
				}
				const d1 = this.$refs.Variant.tableData[0];
				const arr1 = [];
				for( let k in map1){
					if(d1[k] && (d1[k] + '').trim()){
						arr1.push(map1[k]);
					}
				}
				if(arr1.length == 1){
					this.$refs.Variant.variation_theme = arr1[0];
				}
				if (!this.$refs.Variant.variation_theme) {
					this.$message.error('请填写变体主题');
					return false;
				}
			}
			const products = this.countryList.map((item) => {
				// if (item.areaName === 'ZH') {
				item.formData.id = this.productIds[item.areaName] || null
				// }
				return item.formData
			})
			products.forEach((item) => {
				if(this.$refs.Variant.tableData.length > 0){
					item.variationTheme = this.$refs.Variant.variation_theme;
				}
				if (!item.id) delete item.id
			})
			const tableData = JSON.parse(
				JSON.stringify(this.$refs.Variant.tableData)
			)
			let variants = []
			if (tableData.length) {
				// const item of tableData
				for (let i = 0, length = tableData.length; i < length; i++) {
					const item = tableData[i]
					//  console.log(item.productPrice);
					// if (item.imagesList.length <= 0) {
					// 	this.$message.error(
					// 		`${item.sku}变体图片未设置完成，请确认！`
					// 	)
					// 	return false
					// }
					if (item.sku.length > 40) {
						this.$message.error(
							`${item.sku}长度不能超过40位，请确认！`
						)
						return false
					}
					if (parseFloat(item.inputPrice)) {
						/**
						 * 有productId并且areaName不是ZH，说明点开的是单个国家，加减价就直接将当前国家的value加填写的数值inputPrice即可
						 *
						 * 否则就要将inputPrice换算汇率然后每个国家的value加上换算之后的汇率
						 */
						if (this.productId && item.areaName !== 'ZH') {
							const countryItem = item.productPrice[item.areaName]
							// console.log(countryItem.value);
							countryItem.value = this.toDecimal2(
								this.parseNum(countryItem.value) +
								this.parseNum(item.inputPrice)
							)
						} else {
							// console.log(this.exchangeRateList)
							this.exchangeRateList.forEach((key) => {
								// console.log(item.inputPrice);
								// console.log(key.exchangeRate);
								const exchangeRatePrice = this.toDecimal2(
									item.inputPrice / key.exchangeRate
								)
								// console.log( item.productPrice[key.countryCode]);
								for (var i in item.productPrice) {
									if (i == key.countryCode) {
										item.productPrice[i].value = this.toDecimal2(
											this.parseNum(
												item.productPrice[i].value
											) + this.parseNum(exchangeRatePrice)
										)
									}
								}
								// item.productPrice[
								// 	key.countryCode
								// ].value = this.toDecimal2(
								// 	this.parseNum(
								// 		item.productPrice[key.countryCode].value
								// 	) + this.parseNum(exchangeRatePrice)
								// )
							})
						}
					}
					item.productPrice = JSON.stringify(item.productPrice)
					item.variantOrder = i
				}
				variants = tableData
			}
			let product = {
				id: this.productId,
				brand: this.productInfo.brand,
				companyId: this.UserInfo.company_id,
				manufacturer: this.productInfo.manufacturer,
				manufacturerNumber: this.productInfo.manufacturerNumber,
				preprocessingTime: this.productInfo.preprocessingTime,
				productImgUrls: this.productImgArr,
				productSafetyImages: this.safeProductImgArr,
				remarks: this.productInfo.remarks,
				sourceLink: JSON.stringify(this.productInfo.sourceLink),
				sku: this.productInfo.sku,
				productStatus: this.productInfo.productStatus,
				statusAudit: this.productInfo.statusAudit,
				staffId: this.UserInfo.rid,
				stock: this.productInfo.stock,
				eanUpc: this.productInfo.eanUpc,
				variationTheme: this.$refs.Variant.variation_theme,
				productPriceObject: Object.keys(
					this.productInfo.productPriceObject
				).length
					? JSON.stringify(this.productInfo.productPriceObject)
					: null,
			}
			return {
				products,
				product,
				variants,
				productPrice: Object.keys(this.productPrice).length
					? this.productPrice
					: null,
			}
		},
		// 保存
		save() {
			// console.log(this.isTranslate)
			if (this.isTranslate) {
				if (!this.productId) return
			}

			const API = Baseurl + 'productController/insertProduct'
			const paramsData = this.handleSaveData()
			// return;
			if (!paramsData) return
			// 检测基本信息中标题的长度是否超过250个长度
			for (let itemObj of paramsData.products) {
				if (itemObj.title.length > 250) {
					this.$message.warning('标题长度超出限制！')
					return
				}
			}
			if (this.productInfo.statusAudit === '2') {
				if (this.productImgArr.length === 0) {
					this.$message.error('请上传产品图片')
					return
				}
				if (
					!this.productInfo.brand ||
					!this.productInfo.manufacturer ||
					!this.productInfo.stock ||
					!this.productInfo.sku ||
					!this.productInfo.manufacturerNumber ||
					!this.productInfo.preprocessingTime ||
					!this.productInfo.sourceLink ||
					!this.productInfo.productStatus
				) {
					this.$message.error('请将产品信息填写完整')
					return
				}
				if (!Object.keys(this.productInfo.productPriceObject).length) {
					this.$message.error('请将产品信息定价')
					return
				}
			}
			this.isLoading = 'save'
			this.SaveForbid = true
			ajaxPost(API, paramsData)
				.then((res) => {
					const { code, data, message } = res.data
					this.isLoading = ''
					if (code === 200) {
						this.$message({
							type: 'success',
							message: '保存成功!',
						})
						const colors = [];
						const sizes = [];
						const numberOfItems = [];
						const variantTags = [];
						for(let i = 0; i < paramsData.variants.length; i++){
							const item = paramsData.variants[i];
							let textArr = [];
							if(item.color){
								textArr.push('颜色：' + item.color);
							}
							if(item.size){
								textArr.push('尺寸：' + item.size);
							}
							if (item.numberOfItems) {
								textArr.push('产品数量：' + item.numberOfItems);
							}
							const text1 = textArr.join('---');
							if (!variantTags.includes(text1) && text1) {
								variantTags.push(text1)
							}
							if(!colors.includes(item.color) && item.color){
								colors.push(item.color);
							}
							if(!sizes.includes(item.size) && item.size){
								sizes.push(item.size)
							}
							if (!numberOfItems.includes(item.numberOfItems) && item.numberOfItems) {
								textArr.push('产品数量：' + item.numberOfItems);
							}
						}
						// 保存历史变体
						let historyVariant = localStorage.getItem('historyVariant');
						historyVariant = historyVariant ? JSON.parse(historyVariant) : [];
						let texts = [];
						if(colors.length > 0){
							texts.push('颜色：' + colors.join(',')) ;
						}
						if(sizes.length > 0){
							texts.push('尺寸：' + sizes.join(','));
						}
						if (numberOfItems.length > 0) {
							texts.push('产品数量：' + numberOfItems.join(','));
						}
						const textStr = texts.join('，');
						if(!historyVariant.includes(textStr)){
							historyVariant.push(textStr)
						}
						const newHistoryVariant = historyVariant.slice(-5);//只保留五次
						localStorage.setItem('historyVariant', JSON.stringify(newHistoryVariant));


						// 保存变体主题的下拉框
						const variation_theme_list = this.$refs.Variant.variation_theme_list;
						if (!variation_theme_list.includes(this.$refs.Variant.variation_theme)) {
							variation_theme_list.push(this.$refs.Variant.variation_theme)
						}
						localStorage.setItem('variation_theme_list', JSON.stringify(variation_theme_list));


						// 保存历史变体标识
						let historyVariantTag = localStorage.getItem('historyVariantTag');
						historyVariantTag = historyVariantTag ? JSON.parse(historyVariantTag) : [];
						const textStr1 = variantTags.join('，');
						if (!historyVariantTag.includes(textStr1)) {
							historyVariantTag.push(textStr1)
						}
						const newHistoryVariantTag = historyVariantTag.slice(-5);//只保留五次
						localStorage.setItem('historyVariantTag', JSON.stringify(newHistoryVariantTag));

						// 关闭当前标签页
						const targetName = this.$route.path
						this.$store.dispatch('delCrumbList', targetName)
						this.$store.state.user.isSave = false
						this.$store.state.user.isCache = false
						// 判断pageType==='wait',等于就跳转待发布页面，不等于就跳转商品汇总页面
						if (this.pageType === 'wait') {
							this.$router.push({
								name: 'productsToBeReleased',
								params: { country: this.productInfo.areaName },
							})
						} else {
							this.$router.push({ name: 'conmmoditySummary' })
						}
					} else if (code === 500) {
						this.$message.warning(data)
					} else {
						this.$message.error(message)
					}
				})
				.catch((err) => {
					if (err.message == '取消请求') {
						this.isLoading = ''
					}
					// console.log(err)
				})
		},
		startLoadingTranslate(num1 = 0) {
			this.loading = 'translateLoading'
			this.loadingLength = num1
			loadingTime = setInterval(() => {
				const num = Math.floor(Math.random() * 15) + 1
				this.loadingLength += num
				if (this.loadingLength >= 96) {
					this.loadingLength = 96
					clearInterval(loadingTime)
				}
			}, 1500)
			this.loadingTranslate = true

			this.$message.success('翻译中...')
		},
		clearTranslateTimer() {
			this.loadingTranslate = true
			this.loadingLength = 96
			clearInterval(loadingTime)
			clearInterval(translateStatusTimer)
			setTimeout(() => {
				this.loading = 'translateLoading'
			}, 500)
		},
		getTranslateStatus() {
			this.translate(true)
			this.startLoadingTranslate(96)
			const API = Baseurl + 'productController/isTranslate'
			const paramsData = { id: this.productId }
			translateStatusTimer = setInterval(() => {
				ajaxPost(API, paramsData).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						if (data.flag) {
							this.clearTranslateTimer()

							const param = data.param
							this.countryList.forEach((item) => {
								const {
									translateUpperName,
									translateLowerName,
								} = item
								if (translateUpperName !== 'ZH') {
									// 判断属性有没有值，有值就赋值
									param[translateUpperName][
										`${translateLowerName}_title`
									]
										? (item.formData.title =
											param[translateUpperName][
											`${translateLowerName}_title`
											])
										: ''
									// bluePoint是数组，先join后判断属性有没有值，有值就赋值
									param[translateUpperName][
										`${translateLowerName}_bluePoint`
									].join('')
										? (item.formData.bluePoints =
											param[translateUpperName][
											`${translateLowerName}_bluePoint`
											])
										: ''

									param[translateUpperName][
										`${translateLowerName}_keyword`
									]
										? (item.formData.keyword =
											param[translateUpperName][
											`${translateLowerName}_keyword`
											])
										: ''

									param[translateUpperName][
										`${translateLowerName}_briefIntroduction`
									]
										? (item.formData.briefIntroduction =
											param[translateUpperName][
											`${translateLowerName}_briefIntroduction`
											])
										: '';
									
									param[translateUpperName][`${translateLowerName}_titleDifferentiation`] ? (item.formData.titleDifferentiation =
											param[translateUpperName][`${translateLowerName}_titleDifferentiation`])
										: ''
								}
							})
							this.countryVisible = 'all'
						}
					}
				})
			}, 5000)
		},
		// 翻译
		async translate(isNoDown = false) {
			this.SaveForbid = true
			this.isTranslate = true
            const tmList = this.tmList.filter(item => item.source || item.target);
			if (!this.productId) {
				const API = Baseurl + 'productController/insertProduct'
				const paramsData = this.handleSaveData()
				if (!paramsData) return
				// paramsData.product.statusAudit = '3'
				paramsData.isTranslateSave = '1'
				const {
					data: { code, data },
				} = await ajaxPost(API, paramsData)
				if (code === 200) {
					if (data.ids) {
						this.productId = data.ids.ZH
						this.productIds = data.ids
					}
					if (data.priceId) this.productPrice.id = data.priceId
				}
			}

			// const API = 'transcationControllor/translatorChToAllLanguage'
			const API = Baseurl + 'productController/translate'
			const originalData = this.countryList[0].formData
			const parasmData = {}
			for (let item in originalData) {
				if (this.checkList.includes(item)) {
					if (item === 'briefIntroduction') {
						parasmData[item] = originalData[item].replace(
							/&[#\w]{2,4};/g,
							''
						)
					} else {
						parasmData[item] = originalData[item]
					}
				} else {
					if (item === 'bluePoints') {
						parasmData[item] = ['', '', '', '', '']
					} else {
						parasmData[item] = ''
					}
				}
			}
			parasmData.areaName = originalData.areaName
			parasmData.id = this.productId
			parasmData.isNoDown = isNoDown
			parasmData.countryList = this.radio
            if (tmList.length > 0){
                parasmData.tm_list = tmList
            }else{
                parasmData.tm_list = []
            }

			if (isNoDown) {
				ajaxPost(API, parasmData)
				return
			}
			clearInterval(translateStatusTimer)
			this.startLoadingTranslate()
			ajaxPost(API, parasmData)
				.then((res) => {
					if (res.status == 200) {
						this.SaveForbid = true
						const { data } = res
						// this.$message.success(data)
						// if(this.pageType == 'download') {
						// 	this.$router.push({ name: 'conmmoditySummary' })
						// }
						this.countryList.forEach((item) => {
							const {
								translateUpperName,
								translateLowerName,
							} = item
							if (translateUpperName !== 'ZH') {
								// 判断属性有没有值，有值就赋值
								data[translateUpperName][
									`${translateLowerName}_title`
								]
									? (item.formData.title =
										data[translateUpperName][
										`${translateLowerName}_title`
										])
									: ''
								// bluePoint是数组，先join后判断属性有没有值，有值就赋值
								data[translateUpperName][
									`${translateLowerName}_bluePoint`
								].join('')
									? (item.formData.bluePoints =
										data[translateUpperName][
										`${translateLowerName}_bluePoint`
										])
									: ''

								data[translateUpperName][
									`${translateLowerName}_keyword`
								]
									? (item.formData.keyword =
										data[translateUpperName][
										`${translateLowerName}_keyword`
										])
									: ''

								data[translateUpperName][
									`${translateLowerName}_briefIntroduction`
								]
									? (item.formData.briefIntroduction =
										data[translateUpperName][
										`${translateLowerName}_briefIntroduction`
										])
									: ''
								
								data[translateUpperName][
									`${translateLowerName}_titleDifferentiation`
								]
									? (item.formData.titleDifferentiation =
										data[translateUpperName][
										`${translateLowerName}_titleDifferentiation`
										])
									: ''
							}
						})
						this.$router.push({ name: 'conmmoditySummary' })
						this.countryVisible = 'all'
					}
					// else {
					// 	this.$message.error(res.data.data);
					// }
				})
				.catch((err) => {
					// console.log(err)
					// this.$message.error("翻译失败");
					// this.loadingTranslate = false
					// this.loadingLength = 100
					// clearInterval(loadingTime)
					// clearInterval(translateStatusTimer)
					// setTimeout(() => {
					// 	this.loading = ''
					// 	this.SaveForbid = false
					// }, 500)
				})
				.finally(() => {
					// this.clearTranslateTimer()
					this.loadingTranslate = true
					this.loadingLength = 96
					clearInterval(loadingTime)
					clearInterval(translateStatusTimer)
					setTimeout(() => {
						this.loading = 'translateLoading'
						this.SaveForbid = true
					}, 500)
				})
		},
		// 富文本编辑计算长度
		onEditorChange(event, item) {
			item.formData.briefIntroduction = event.html.replace(
				/((?<=<)|(?<=<\/))(ul|li|h[1-6])/gm,
				'p'
			)
			event.quill.deleteText(2000, 4)
			const editorLength = event.quill.getLength() - 1
			item.editorLength = editorLength
		},
		// 同步翻译
		translateSync() {
			// console.log(this.translateSyncList);
			try {
				const countryInfo = this.countryList[this.currentCountryIndex]
				const countryTag = countryInfo.areaName
				const translateData = this.countryList.find(
					(item) => item.areaName === countryTag
				)
				this.countryList.forEach((item) => {
					const isSync =
						this.translateSyncList.includes(item.areaName) &&
						item.areaName !== countryTag
					if (isSync) {
						item.formData.title = translateData.formData.title
						item.formData.bluePoints =
							translateData.formData.bluePoints
						item.formData.keyword = translateData.formData.keyword
						item.formData.briefIntroduction =
							translateData.formData.briefIntroduction
						item.formData.titleDifferentiation =
							translateData.formData.titleDifferentiation
						// item.formData = { ...translateData.formData };
					}
				})
				this.$message.success('同步完成')
			} catch (error) {
				console.log(error)
				this.$message.warning('同步出错')
			}
		},
		// // 初始化富文本编辑器
		// initUE() {
		//     this.editor = window.UE.getEditor("editor", this.config);
		//     // 初始化UE
		//     this.editor.addListener("ready", () => {
		//         this.editor.setContent(this.formData);
		//         // 确保UE加载完成后，放入内容。
		//     });
		// },
		handleIconClick() {
			let arr = this.sharecloaim.toLowerCase().split(' ')
			let newArr = []
			for (let i = 0; i < arr.length; i++) {
				if (arr[i] === '') {
					this.$message.error('后面不能有空格')
				} else {
					newArr.push(arr[i][0].toUpperCase() + arr[i].substr(1))
				}
			}
			this.sharecloaim = newArr.join(' ')
		},
		changeCurrentCountry(index) {
			if (this.currentCountryIndex === index) return
			this.currentCountryIndex = index
			this.$nextTick(() => {
				this.$refs.customTextarea.forEach((item) =>
					item.resizeTextarea()
				)
			})
		},
		toDecimal2(x) {
			var f = parseFloat(x)
			if (isNaN(f)) {
				return '0.00'
			}
			var f = Math.round(x * 100) / 100
			var s = f.toString()
			var rs = s.indexOf('.')
			if (rs < 0) {
				rs = s.length
				s += '.'
			}
			while (s.length <= rs + 2) {
				s += '0'
			}
			return s
		},
		parseNum(num) {
			let result = Number(num)
			if (isNaN(result)) {
				return 0
			}
			return result
		},
		// ManualTranslation() {
		// 	const API = Baseurl + 'productController/updateProductTranslate'
		// 	const paramsData = {
		// 		id: this.productId
		// 	}
		// 	ajaxPost(API, paramsData)
		// 		.then((res) => {
		// 			if(res.data.code == 200) {
		// 				this.getProductInfo()
		// 			}else {
		// 				this.$message.error(res.data.data)
		// 			}
		// 		})
		// },
		downloadImgs() {
			const API =
				Baseurl + 'imageController/downlowndImage?id=' + this.productId
			ajaxPost(API)
				.then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						const AElement = document.createElement('a')
						AElement.href = data
						AElement.click()
						this.$message.success('正在下载...')
					}
				})
				.catch(() => {
					this.$message.error('下载失败...')
				})
		},
		priceChange(value) {
			this.$refs.Variant.priceChange(value)
		},
		handleCheckAllChange() {
			const isAllSelect = !!this.checkList.length
			this.checkList = isAllSelect
				? []
				: ['title', 'titleDifferentiation', 'bluePoints', 'keyword', 'briefIntroduction']
		},
		formatInputValue(value, field) {
			if (!value) return
			const strArr = value.split(' ')
			const newArr = []
			const whiteList = [
				'a',
				'an',
				'are',
				'is',
				'on',
				'of',
				'for',
				'and',
				'or',
				'the',
			]
			strArr.forEach((item) => {
				if (!whiteList.includes(item)) {
					item = item.charAt(0).toUpperCase() + item.slice(1)
				}
				newArr.push(item)
			})
			this.countryList[
				this.currentCountryIndex
			].formData[field] = newArr.join(' ')
		},
		detectingSensitiveWords() {
			const API =
				Baseurl + 'sensitiveWordsController/detectSensitiveWords'
			let str = ''
			const tempArr = this.countryList.map((item) => item.formData)
			tempArr.forEach((item) => {
				const tempStr = `${item.title} ${item.bluePoints.join(' ')} ${item.keyword
					} ${item.briefIntroduction} `
				str += tempStr
			})
			const paramsData = { str }
			// this.loadingDetection = true
			ajaxPost(API, paramsData).then((res) => {
				this.loadingDetection = false
				const { code, data } = res.data
				if (code === 200) {
					if (typeof data === 'string') {
						this.$message.success(data)
						return
					}
					for (const key in data) {
						console.log(data[key])
						this.copyKey = data[key].words
						this.sensitiveWords += `
                        <p>
                        <span style="color: red;">敏感词汇：</span>
                        ${key}
                        <span style="color: green;margin-left: 20px;">处理办法：</span>
                        ${data[key].method}\n
                        <span style="margin-left: 20px;">国家：</span>
                        ${data[key].countryName}\n
                        <span style="margin-left: 20px;">分类：</span>
                        ${data[key].classifyContent}\n
                        </p>`
					}
					this.dialogSensitiveVisible = true
				} else {
					this.$message.error(data)
				}
			})
		},
		copySensitive() {
			const inputEle = document.createElement('input')
			document.body.appendChild(inputEle)
			const tempValue = this.copyKey
			inputEle.value = tempValue
			inputEle.style.position = 'fixed'
			inputEle.style.top = '-100px'
			inputEle.style.left = '-100px'
			inputEle.value = tempValue
			inputEle.select()
			if (document.execCommand('copy')) {
				document.execCommand('copy')
				this.$message.success('复制成功！')
			}
			document.body.removeChild(inputEle)
		},
	},
}
// }
</script>
<style lang="scss" scoped>
/deep/ {
	.el-textarea__inner:focus {
		outline: 0;
		border-color: #cce198;
	}

	.custom-border-blue:not([class*='is-exceed']) .el-textarea__inner {
		border: 1px solid blue;
	}

	.custom-border-green:not([class*='is-exceed']) .el-textarea__inner {
		border: 1px solid green;
	}

	.custom-border-purple:not([class*='is-exceed']) .el-textarea__inner {
		border: 1px solid purple;
	}

	.el-checkbox-group {
		font-size: 16px !important;
	}

	.el-checkbox {
		float: left;
		line-height: 33px;
	}

	.el-checkbox__label {
		font-size: 0;
	}
}
</style>
<style lang="scss">
.EstablishProduct {
	width: 98%;
	min-width: 1620px;
	margin: auto;

	.product_number {
		line-height: 30px;
	}

	.and_pictures {
		line-height: 30px;
		border-bottom: #8d8e8f 1px solid;
	}

	.Ministerborder {
		padding: 0 0 3px 0;
		border: 1px solid #d7f0dbff;
		margin: 1% 0;
	}

	.informationborder {
		border: 1px solid #cce6ff;
	}

	.productborder {
		border: 1px solid #fde6d2;
	}

	.information {
		min-height: 800px;
		border: 1px solid #e6f5c2;
		margin-top: 1%;
		position: relative;

		.info-box-mask {
			width: 100%;
			height: 100%;
			background: rgba(255, 255, 255, 0.7);
			position: absolute;
			top: 0;
			left: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 999;
		}
	}

	.Minister-top {
		width: 99%;
		border-radius: 4px;
		overflow: hidden;

		.Minister-top-top {
			width: 100%;
			height: 40px;

			.Minister-top-left {
				width: 180px;
				line-height: 40px;
				float: left;
				text-align: center;
				font-size: 16px;
				color: #fff;
			}

			.Minister-top-color {
				// color: #567801;
				background: #39b54a;
			}

			.product-top-color {
				// color: #000;
				background: #f37b1d;
			}

			.information-top-color {
				// color: #026695;
				background: #0081ff;
			}

			.Minister-top-right {
				width: 80px;
				line-height: 40px;
				float: right;
				font-size: 16px;
				text-align: center;
			}
		}

		.Ministerbackground {
			background: #d7f0dbff;
		}

		.productbackground {
			background: #fde6d2;
		}

		.informationbackground {
			background: #bfe2f3;
		}

		.productimgs {
			padding: 10px;
		}

		.classification {
			margin-left: 50px;
			margin-top: 10px;
			padding: 0 0 20px 0;
			overflow: hidden;

			.classification_left {
				width: 55%;
				overflow: hidden;
				float: left;

				.classification_content {
					overflow: hidden;

					.station_left {
						width: 14%;
						line-height: 40px;
						float: left;
					}

					.station_left:before {
						content: '*';
						line-height: 40px;
						float: left;
						width: 11%;
					}

					.station_right {
						float: right;
						width: 86%;

						div {
							width: 100%;
							color: #c19898;
							line-height: 40px;
						}
					}
				}
			}

			.classification_right {
				width: 100%;
				padding: 5px 10px 5px 0;
				margin-top: 25px;
				box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

				// float: left;
				.elasticFrame {
					padding: 10px 0;
					width: 100%;

					.elasticFrame_classification {
						width: 20%;
						text-align: right;
						float: left;
						line-height: 30px;
						margin-right: 2%;
					}

					.el-input {
						width: 72%;
					}

					.el-button--primary {
						margin-left: 22%;
					}
				}

				.Preservation {
					float: right;
					padding: 5px 10px;
					background: #73ade9;
					color: #fff;
					margin-top: 20px;
					border-radius: 5px;
					cursor: pointer;
					margin-bottom: 20px;
				}
			}
		}

		.information_content {
			width: 96%;
			margin: auto;
			overflow: hidden;
			padding: 10px 0;

			.information_Mandarin {
				overflow: hidden;
				// margin-left: 4%;
				display: flex;
				justify-content: space-between;

				ul {
					max-width: 1450px;
					flex: 1;
					display: flex;

					li {
						width: 90px;
						height: 35px;
						line-height: 35px;
						text-align: center;
						// float: left;
						cursor: pointer;
					}

					.liactive {
						background: #2c8dff;
						color: #fff;
					}
				}
			}

			.information_tips {
				line-height: 50px;
				margin-left: 10%;
				color: #f89a9a;
				font-size: 16px;
			}

			.information_input {
				overflow: hidden;
				position: relative;

				.region {
					width: 80px;
					height: 80px;
					background: rgba(0, 0, 0, 0);
					// background: red;
					position: absolute;
					left: 0px;
					top: 50px;
				}

				.information_Title {
					width: 6%;
					overflow: hidden;
					color: #7d7171;
					text-align: right;
					float: left;
					line-height: 33px;
					margin-right: 1%;
					font-weight: bold;
					user-select: none;

					.tips {
						color: red;
					}
				}

				.input_el {
					width: 92%;
					float: left;

					.Preservation {
						float: right;
						padding: 10px 10px;
						background: #73ade9;
						color: #fff;
						margin-top: 5px;
						border-radius: 5px;
					}
				}
			}
		}
	}

	.EstablishProduct_bottom {
		position: fixed;
		right: 60px;
		top: 116px;
		z-index: 1000;

		.el-button {
			padding: 10px 40px;
			font-size: 16px;
		}

		// cursor: pointer;
		// span {
		//     padding: 5px 10px;
		//     color: #fff;
		//     border-radius: 5px;
		// }
		// span:nth-child(1) {
		//     background: #67c23a;
		// }
		// span:nth-child(2) {
		//     background: #409eff;
		// }
	}

	.uploaderImg .el-upload__text {
		width: 100%;
		height: 28px;
		text-align: center;
	}

	.rs-tab {
		width: 853px;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		margin-top: 10px;
		padding: 10px 0;
		line-height: 25px;
	}

	.rs-tab li {
		display: inline-block;
	}

	.newipt {
		margin-left: 26px;
	}

	.newipt:nth-child(1) {
		margin-left: 0;
	}

	.ql-container {
		.ql-editor {
			min-height: 300px;
			font-size: 16px;
		}
	}
}
.fanyi-box{
    display: flex;
    max-height: 650px;
    overflow-y: auto;
    justify-content: space-between;
    .fanyi-item{
        width: calc(50% - 10px);
        max-height: 100%;
        overflow-y: auto;
        &.array{
            .title{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                .text{
                    font-size: 18px;
                    color: #333;
                }
            }
            .tm-box{
                .tm-tip{
                    font-size: 16px;
                    margin-bottom: 20px;
                }
                .tm-row{
                    display: flex;
                    margin-bottom: 5px;
                    .tm-text{
                        white-space: nowrap;
                        width: 80px;
                        text-align: left;
                    }
                    .tm-val{
                        flex: 1;
                    }
                }
            }
        }
    }
}
.select-css {
	border: 1px solid #c1c1c1;
	padding: 5px;
	border-radius: 5px;
}

.jc-sb {
	display: flex;
	justify-content: space-between;
}

.aiCss {
	display: flex;
	align-items: center;
}
</style>
